// src/pages/Register/StepAgent.jsx

import { useContext } from "react";
import InputPro from "../../components/ui/InputPro";
import Button from "../../components/ui/Button";
import { LanguageContext } from "../../context/LanguageContext";

export default function StepAgent({
  profileData,
  updateProfileData,
  prevStep,
  submit,
  loading,
}) {
  const { lang, t } = useContext(LanguageContext);
  const isRTL = lang === "ar";

  const handleChange = (e) =>
    updateProfileData({ [e.target.name]: e.target.value });

  return (
    <div className="space-y-6" dir={isRTL ? "rtl" : "ltr"}>
      {/* TITLE */}
      <h2
        className={`text-xl font-semibold text-gray-900 dark:text-white ${
          isRTL ? "text-right" : "text-left"
        }`}
      >
        {t("agent.title")}
      </h2>

      {/* FIELDS */}
      <InputPro
        label={t("agent.first_name")}
        name="first_name"
        required
        value={profileData.first_name || ""}
        onChange={handleChange}
      />

      <InputPro
        label={t("agent.last_name")}
        name="last_name"
        required
        value={profileData.last_name || ""}
        onChange={handleChange}
      />

      <InputPro
        label={t("agent.bio")}
        name="bio"
        value={profileData.bio || ""}
        onChange={handleChange}
      />

      <InputPro
        label={t("agent.skills")}
        name="skills"
        value={profileData.skills || ""}
        onChange={handleChange}
        helperText={t("agent.skills_hint") || "e.g. sales, marketing"}
      />

      {/* ACTIONS */}
      <div
        className={`flex gap-3 pt-4 ${
          isRTL ? "flex-row-reverse" : ""
        }`}
      >
        <Button variant="secondary" onClick={prevStep}>
          {t("common.back")}
        </Button>

        <Button
          variant="primary"
          loading={loading}
          onClick={submit}
        >
          {t("agent.submit")}
        </Button>
      </div>
    </div>
  );
}
